export const BrazeEvents = {
  PATIENT_INVITED: "Invited Patient",
};
